// 用户实体表 用户的最原始定义信息
import { DB, ExecuteResult, SQLBatchTuple } from './index';
import time from '../time';
import log from '../log';

const upsert_sql =
    'INSERT INTO t_user(' +
    ' uid, name, name_py, name_pys, nick, sex, birth,' +
    ' privacy, nick_py, nick_pys, telno, email, employee,' +
    ' position, present, titles, department, employee_id, appkey, main_appkey,' +
    ' avatar, status, remark, remark_py, remark_pys,' +
    ' rtel, rtelCheck, remail, remailCheck, qrcode, qrcode_desc,' +
    ' lutime, lctime' +
    ') VALUES (' +
    ' ?, ?, ?, ?, ?, ?, ?,' +      // 7个
    ' ?, ?, ?, ?, ?, ?,' +         // 6个
    ' ?, ?, ?, ?, ?, ?, ?,' +      // 7个
    ' ?, ?, ?, ?, ?,' +            // 5个
    ' ?, ?, ?, ?, ?, ?,' +         // 6个
    ' ?, ?' +                      // 2个 - 总共34个问号
    ') ON CONFLICT(uid) DO UPDATE SET' +
    ' name=EXCLUDED.name, name_py=EXCLUDED.name_py, name_pys=EXCLUDED.name_pys,' +
    ' nick=EXCLUDED.nick, sex=EXCLUDED.sex, birth=EXCLUDED.birth,' +
    ' privacy=EXCLUDED.privacy, nick_py=EXCLUDED.nick_py, nick_pys=EXCLUDED.nick_pys,' +
    ' telno=EXCLUDED.telno, email=EXCLUDED.email, employee=EXCLUDED.employee,' +
    ' position=EXCLUDED.position, present=EXCLUDED.present, titles=EXCLUDED.titles,' +
    ' department=EXCLUDED.department, employee_id=EXCLUDED.employee_id,' +
    ' appkey=EXCLUDED.appkey, main_appkey=EXCLUDED.main_appkey,' +
    ' avatar=EXCLUDED.avatar, status=EXCLUDED.status, remark=EXCLUDED.remark,' +
    ' remark_py=EXCLUDED.remark_py, remark_pys=EXCLUDED.remark_pys,' +
    ' rtel=EXCLUDED.rtel, rtelCheck=EXCLUDED.rtelCheck, remail=EXCLUDED.remail,' +
    ' remailCheck=EXCLUDED.remailCheck, qrcode=EXCLUDED.qrcode, qrcode_desc=EXCLUDED.qrcode_desc,' +
    ' lutime=EXCLUDED.lutime;';


export async function user_upsert(db: DB, user: User): Promise<ExecuteResult> {
    if (user.uid === undefined || user.uid <= 0) {
        log.warn('BUG!!!user_upsert uid为0', JSON.stringify(user));
        return { error: null, insertId: 0, rowsAffected: 0 };
    }
    const d = UserToEntity(fixUser(user));

    const timeUNIX = time.toUnixMillSecond(time.now());
    d.lutime = timeUNIX;
    d.lctime = timeUNIX;

    const params = [];

    // 只需要INSERT的参数（34个）
    params.push(...[d.uid, d.name, d.name_py, d.name_pys, d.nick, d.sex, d.birth]);
    params.push(...[d.privacy, d.nick_py, d.nick_pys, d.telno, d.email, d.employee]);
    params.push(...[d.position || '', d.present || '', d.titles || '', d.department, d.employee_id, d.appkey, d.main_appkey]);
    params.push(...[d.avatar, d.status, d.remark, d.remark_py, d.remark_pys]);
    params.push(...[d.rtel, d.rtelCheck, d.remail, d.remailCheck, d.qrcode, d.qrcode_desc]);
    params.push(...[d.lutime, d.lctime]);

    return await db.Execute(upsert_sql, params);
}

/** 批量写入用户信息 */
export async function user_batch_upsert(db: DB, users: User[]): Promise<{ error: any }> {
    const commands: SQLBatchTuple[] = [];
    const timeUNIX = time.toUnixMillSecond(time.now());
    for (const user of users) {
        if (user.uid === undefined || user.uid <= 0) {
            continue;
        }
        const d = UserToEntity(fixUser(user));
        d.lutime = timeUNIX;
        d.lctime = timeUNIX;
        const params: any[] = [];
        params.push(...[d.uid, d.name, d.name_py, d.name_pys, d.nick, d.sex, d.birth]);
        params.push(...[d.privacy, d.nick_py, d.nick_pys, d.telno, d.email, d.employee]);
        params.push(...[d.position || '', d.present || '', d.titles || '', d.department, d.employee_id, d.appkey, d.main_appkey]);
        params.push(...[d.avatar, d.status, d.remark, d.remark_py, d.remark_pys]);
        params.push(...[d.rtel, d.rtelCheck, d.remail, d.remailCheck, d.qrcode, d.qrcode_desc]);
        params.push(...[d.lutime, d.lctime]);
        commands.push([upsert_sql, params]);
    }
    if (commands.length === 0) return { error: null };
    const r = await db.BatchExecute(commands);
    return { error: 'user_batch_upsert error' };
}

export type UserModifyCond = {
    uid: number; // 必填
    avatar?: string;
    remark?: string;
};

// 修改用户信息
export async function user_modify(
    db: DB,
    cond: UserModifyCond,
): Promise<ExecuteResult> {
    const params = [];
    const fields = [];
    if (cond.avatar !== undefined) {
        fields.push('avatar=?');
        params.push(cond.avatar);
    }
    if (cond.remark !== undefined) {
        fields.push('remark=?');
        params.push(cond.remark);
    }
    if (fields.length <= 0) {
        log.warn('user_modify 没有有效更新字段 cond:', JSON.stringify(cond));
        return { error: null, rowsAffected: 0, insertId: 0 };
    }

    const sql = 'update t_user set ' + fields.join(',') + ' where uid=?';
    params.push(cond.uid);
    return await db.Execute(sql, params);
}

// 检查有哪些数据
export async function user_exists(
    db: DB,
    uidList: number[],
): Promise<{ error: any; exists?: number[] }> {
    // 过滤无效 uid
    uidList = (uidList || []).map(u => Number(u)).filter(u => Number.isFinite(u) && Number.isInteger(u));
    if (uidList.length === 0) return { error: null };

    // 动态生成占位符 ?, ?, ?
    const placeholders = uidList.map(() => '?').join(', ');
    const sql = `SELECT uid FROM t_user WHERE uid IN (${placeholders})`;

    const r = await db.Query(sql, uidList);
    if (r.error) return { error: r.error };

    // 提取 uid 数组
    const exists = r.data && r.data.length > 0
        ? (r.data as { uid: number }[]).map(item => item.uid)
        : [];

    return { error: null, exists };
}


export async function user_query(
    db: DB,
    uids: number[],
): Promise<{ error: any; users?: User[] }> {
    uids = (uids || []).map(u => Number(u)).filter(u => Number.isFinite(u) && Number.isInteger(u));

    if (uids.length === 0) return { error: null };

    const placeholders = uids.map(() => '?').join(', ');

    const sqlstr = `SELECT * FROM t_user WHERE uid IN (${placeholders})`;

    const r = await db.Query(sqlstr, uids);
    if (r.error) return { error: r.error };
    if (!r.data || r.data.length === 0) return { error: null };

    const arr: User[] = (r.data as Entity[]).map(EntityToUser);
    return { error: null, users: arr };
}


export async function user_query_one(
    db: DB,
    uid: number,
): Promise<{ error: any; user?: User }> {
    const sql = 'select * from t_user where uid=?';
    const r = await db.Query(sql, [uid]);
    if (r.error) {
        return { error: r.error };
    }
    if (!(r.data && r.data.length > 0)) {
        return { error: null };
    }
    const d = r.data[0] as Entity;
    return { error: null, user: EntityToUser(d) };
}

function EntityToUser(a: Entity): User {
    const b: User = {
        uid: a.uid, // uid
        name: a.name, // 名称
        sex: a.sex, //
        birth: a.birth, //
        privacy: a.privacy, //
        namePY: a.name_py, // 名称 拼音
        namePYS: a.name_pys, // 名称 拼音首字母
        nick: a.nick, // 昵称
        nickPY: a.nick_py, // 昵称 拼音
        nickPYS: a.nick_pys, // 昵称 拼音首字母
        telno: a.telno, // 手机号 登陆时作为账号
        email: a.email, // 邮箱 登陆时作为账号
        employee: a.employee, // 员工的账号 登陆时作为账号
        position: a.position, // 职位 "超级管理员"
        present: a.present, // 在线状态 "online" - 在线 "offline" - 离线 "busy" - 忙碌 "away" - 离开 "invisible" - 隐身 "do_not_disturb" - 不要打扰
        titles: a.titles, // 职称、标签等, 使用,分割
        department: a.department, // 部门id
        employeeID: a.employee_id, // 工号
        appkey: a.appkey, // 应用 关联到具体某个公司
        mainAppkey: a.main_appkey, // 主应用 多个公司
        avatar: a.avatar, // 头像
        status: a.status, // 状态 空-正常开启状态 closed-关闭状态 deleted-删除
        remark: a.remark, // 不是表字段 备注
        remarkPY: a.remark_py, // 不是表字段 备注拼音
        remarkPYS: a.remark_pys, // 不是表字段 备注拼音首字母
        rtel: a.rtel,     //备注手机号码
        rtelCheck: a.rtelCheck, //手机号码是否验证，"1"-验证，其余未验证
        remail: a.remail,   //备注邮箱
        remailCheck: a.remailCheck,//邮箱是否验证，"1"-验证，其余未验证
        qrcode: a.qrcode,
        qrcode_desc: a.qrcode_desc,
        lutime: a.lutime,
        lctime: a.lctime,
    };
    return b;
}

function UserToEntity(a: User): Entity {
    const b: Entity = {
        uid: a.uid, // uid
        name: a.name, // 名称
        sex: a.sex, //
        birth: a.birth, //
        privacy: a.privacy, //
        name_py: a.namePY, // 名称 拼音
        name_pys: a.namePYS, // 名称 拼音首字母
        nick: a.nick, // 昵称
        nick_py: a.nickPY, // 昵称 拼音
        nick_pys: a.nickPYS, // 昵称 拼音首字母
        telno: a.telno, // 手机号 登陆时作为账号
        email: a.email, // 邮箱 登陆时作为账号
        employee: a.employee, // 员工的账号 登陆时作为账号
        position: a.position || '', // 职位 "超级管理员"
        present: a.present || '', // 在线状态 "online" - 在线 "offline" - 离线 "busy" - 忙碌 "away" - 离开 "invisible" - 隐身 "do_not_disturb" - 不要打扰
        titles: a.titles || '', // 职称、标签等, 使用,分割
        department: a.department, // 部门id
        employee_id: a.employeeID, // 工号
        appkey: a.appkey, // 应用 关联到具体某个公司
        main_appkey: a.mainAppkey, // 主应用 多个公司
        avatar: a.avatar, // 头像
        status: a.status, // 状态 空-正常开启状态 closed-关闭状态 deleted-删除
        remark: a.remark, // 不是表字段 备注
        remark_py: a.remarkPY, // 不是表字段 备注拼音
        remark_pys: a.remarkPYS, // 不是表字段 备注拼音首字母
        rtel: a.rtel,     //备注手机号码
        rtelCheck: a.rtelCheck, //手机号码是否验证，"1"-验证，其余未验证
        remail: a.remail,   //备注邮箱
        remailCheck: a.remailCheck,//邮箱是否验证，"1"-验证，其余未验证
        qrcode: a.qrcode,//个人二维码
        qrcode_desc: a.qrcode_desc,//个人二维码描述
        lutime: a.lutime,
        lctime: a.lctime,
    };
    return b;
}

function fixUser(a: User): User {
    return Object.assign({}, defaultUser, a);
}

export type User = {
    uid: number; // uid
    name: string; // 名称
    sex: string; //"0"-女，"1"-男，"2"-未知
    birth: string; //
    privacy: string; //是否公开账号，1-不公开账号，其余都是公开账号
    namePY: string; // 名称 拼音
    namePYS: string; // 名称 拼音首字母
    nick: string; // 昵称
    nickPY: string; // 昵称 拼音
    nickPYS: string; // 昵称 拼音首字母
    telno: string; // 手机号 登陆时作为账号
    email: string; // 邮箱 登陆时作为账号
    employee: string; // 员工的账号 登陆时作为账号
    position: string; // 职位 "超级管理员"
    present: string; // 在线状态 "online" - 在线 "offline" - 离线 "busy" - 忙碌 "away" - 离开 "invisible" - 隐身 "do_not_disturb" - 不要打扰
    titles: string; // 职称、标签等, 使用,分割
    department: string; // 部门id
    employeeID: string; // 工号
    appkey: string; // 应用 关联到具体某个公司
    mainAppkey: string; // 主应用 多个公司
    avatar: string; // 头像
    status: string; // 状态 空-正常开启状态 closed-关闭状态 deleted-删除
    remark: string; // 不是表字段 备注
    remarkPY: string; // 不是表字段 备注拼音
    remarkPYS: string; // 不是表字段 备注拼音首字母
    rtel: string;     //备注手机号码
    rtelCheck: string; //手机号码是否验证，"1"-验证，其余未验证
    remail: string;   //备注邮箱
    remailCheck: string;//邮箱是否验证，"1"-验证，其余未验证
    qrcode: string;//个人二维码
    qrcode_desc: string;//个人二维码描述
    // 本地
    lutime: number;
    lctime: number;
};
export const defaultUser: User = {
    uid: 0, // uid
    name: '', // 名称
    sex: '', //
    birth: '', //
    privacy: '', //
    namePY: '', // 名称 拼音
    namePYS: '', // 名称 拼音首字母
    nick: '', // 昵称
    nickPY: '', // 昵称 拼音
    nickPYS: '', // 昵称 拼音首字母
    telno: '', // 手机号 登陆时作为账号
    email: '', // 邮箱 登陆时作为账号
    employee: '', // 员工的账号 登陆时作为账号
    position: '', // 职位 "超级管理员"
    present: '', // 在线状态 "online" - 在线 "offline" - 离线 "busy" - 忙碌 "away" - 离开 "invisible" - 隐身 "do_not_disturb" - 不要打扰
    titles: '', // 职称、标签等, 使用,分割
    department: '', // 部门id
    employeeID: '', // 工号
    appkey: '', // 应用 关联到具体某个公司
    mainAppkey: '', // 主应用 多个公司
    avatar: '', // 头像
    status: '', // 状态 空-正常开启状态 closed-关闭状态 deleted-删除
    remark: '', // 不是表字段 备注
    remarkPY: '', // 不是表字段 备注拼音
    remarkPYS: '', // 不是表字段 备注拼音首字母
    rtel: '',     //备注手机号码
    rtelCheck: '', //手机号码是否验证，"1"-验证，其余未验证
    remail: '',   //备注邮箱
    remailCheck: '',//邮箱是否验证，"1"-验证，其余未验证
    qrcode: '',//个人二维码
    qrcode_desc: '',//个人二维码描述
    lutime: 0,
    lctime: 0,
};

type Entity = {
    uid: number; // uid
    name: string; // 名称
    sex: string; //
    birth: string; //
    privacy: string; //是否公开账号，1-不公开账号，其余都是公开账号
    name_py: string; // 名称 拼音
    name_pys: string; // 名称 拼音首字母
    nick: string; // 昵称
    nick_py: string; // 昵称 拼音
    nick_pys: string; // 昵称 拼音首字母
    telno: string; // 手机号 登陆时作为账号
    email: string; // 邮箱 登陆时作为账号
    employee: string; // 员工的账号 登陆时作为账号
    position: string; // 职位 "超级管理员"
    present: string; // 在线状态 "online" - 在线 "offline" - 离线 "busy" - 忙碌 "away" - 离开 "invisible" - 隐身 "do_not_disturb" - 不要打扰
    titles: string; // 职称、标签等, 使用,分割
    department: string; // 部门id
    employee_id: string; // 工号
    appkey: string; // 应用 关联到具体某个公司
    main_appkey: string; // 主应用 多个公司
    avatar: string; // 头像
    status: string; // 状态 空-正常开启状态 closed-关闭状态 deleted-删除
    remark: string; // 不是表字段 备注
    remark_py: string; // 不是表字段 备注拼音
    remark_pys: string; // 不是表字段 备注拼音首字母
    rtel: string;     //备注手机号码
    rtelCheck: string; //手机号码是否验证，"1"-验证，其余未验证
    remail: string;   //备注邮箱
    remailCheck: string;//邮箱是否验证，"1"-验证，其余未验证
    qrcode: string;//个人二维码
    qrcode_desc: string;//个人二维码描述
    // 本地
    lutime: number;
    lctime: number;
};
